import React from 'react'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import ChatListNavUI from '../../../components/superUser/account/ChatListNavUI.js'
import ChatMessageListSF from '../../../components/superUser/account/ChatMessageListSF.js'
import EmptyListUI from '../../../widgets/output/EmptyListUI.js'

const ChatRecentUI = ({ context, errorList, userMessageList, onRefreshClick }) =>
  <SuperUserHomePageUI context={context} className='pg_su_cht_r' topnav='accounts'
    centered={!userMessageList} page='recentChat'
  >
    {
      !errorList && !userMessageList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      userMessageList &&
      <div>
        <ChatListNavUI page='recent' />

        <ChatMessageListSF
          context={context}
          userMessageList={userMessageList}
          onRefreshClick={onRefreshClick}
        />
      </div>
    }
    {
      userMessageList && userMessageList.length === 0 &&
      <EmptyListUI
        context={context} className='g_m_top_200'
        createDisabledMessageLabel='No messages'
      />
    }
  </SuperUserHomePageUI>

export default ChatRecentUI
